import {css} from 'styled-components'

const containerBottomStage = css`
    background-color: ${(props) => props.theme.colors.background.primary};
    position: relative;
`

export default containerBottomStage
